// ═══ VACCINURI TAB ═══════════════════════════════════════════════════════════
import React, { useState } from "react";
import { t } from './i18n';
import { fmAlert, fmConfirm } from './dialog';
import { fmtD } from './helpers';
import { VACCINE_LIST } from './data';
import { CaregiverBadge, DatePicker, Dropdown, IconTrash } from './ui';

export function VaccinuriTab({vaccines, setModal, onDeleteVaccine, family, readOnly=false}) {
  const sorted = [...vaccines].sort((a,b)=>(b.date||"").localeCompare(a.date||""));
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div/>
        {!readOnly&&<button className="bp" style={{fontSize:12,padding:"7px 14px"}} onClick={()=>setModal({type:"addVaccine"})}>+ {t("Vaccin")}</button>}
      </div>
      {sorted.length===0&&<div style={{padding:"24px 0",color:"var(--text-4)",textAlign:"center",fontSize:13}}>{t("Niciun vaccin înregistrat. Apasă „+ Vaccin\" pentru a adăuga.")}</div>}
      {sorted.map(v=>(
        <div key={v._dbId} className="card" style={{marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:14}}>{t(v.name)}</div>
            <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>
              {v.date&&<span>📅 {fmtD(v.date)}</span>}
              {v.dose&&<span style={{marginLeft:10}}>{t("Doza:")} {v.dose}</span>}
            </div>
            {v.note&&<div style={{fontSize:12,color:"var(--text-2)",marginTop:4,whiteSpace:"pre-wrap"}}>{v.note}</div>}
            {v.nextDate&&<div style={{fontSize:12,color:"#f59e0b",marginTop:4}}>⏰ {t("Următoarea doză:")} {fmtD(v.nextDate)}</div>}
          </div>
          <div style={{display:"flex",gap:6,flexShrink:0,alignItems:"center"}}>
            <CaregiverBadge addedBy={v.addedBy} addedByName={v.addedByName} addedByEmail={v.addedByEmail} family={family} size={16}/>
            {!readOnly&&<button className="bg" style={{fontSize:11,padding:"4px 8px"}} onClick={()=>setModal({type:"addVaccine",data:v})}>✎</button>}
            {!readOnly&&<button className="bdel" onClick={()=>fmConfirm(t("Ștergi acest vaccin?"),{danger:true,okText:"Șterge"}).then(ok=>{if(ok)onDeleteVaccine(v._dbId);})}><IconTrash/></button>}
          </div>
        </div>
      ))}
    </div>
  );
}

export function AddVaccineForm({initial, onAdd}) {
  const today=new Date();
  const todayStr=`${String(today.getDate()).padStart(2,"0")}.${String(today.getMonth()+1).padStart(2,"0")}.${today.getFullYear()}`;
  function isoToDisplay(iso){ if(!iso)return ""; const[y,m,d]=iso.split("-"); return `${d}.${m}.${y}`; }
  function displayToISO(d){ if(!d)return ""; const p=d.split("."); if(p.length!==3)return d; return `${p[2]}-${p[1].padStart(2,"0")}-${p[0].padStart(2,"0")}`; }

  const [name, setName] = useState(initial?.name||"");
  const [customName, setCustomName] = useState("");
  const [date, setDate] = useState(initial?.date?isoToDisplay(initial.date):todayStr);
  const [dose, setDose] = useState(initial?.dose||"");
  const [note, setNote] = useState(initial?.note||"");
  const [nextDate, setNextDate] = useState(initial?.nextDate?isoToDisplay(initial.nextDate):"");

  const finalName = name==="__custom__" ? customName : name;

  return (
    <div>
      <div style={{marginBottom:12}}>
        <div className="lbl">{t("Vaccin")}</div>
        <Dropdown value={name} onChange={v=>setName(v)} placeholder={t("— Selectează —")}
          options={[
            ...Object.entries(VACCINE_LIST).flatMap(([group, items])=>[{header:true,l:group}, ...items.map(v=>({v,l:v}))]),
            {v:"__custom__",l:t("Altul (scrie manual)")},
          ]}/>
      </div>
      {name==="__custom__"&&(
        <div style={{marginBottom:12}}>
          <div className="lbl">{t("Nume vaccin")}</div>
          <input value={customName} onChange={e=>setCustomName(e.target.value)} placeholder={t("ex: Vaccin specific")}/>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
        <div><div className="lbl">{t("Data administrării")}</div><DatePicker value={date} onChange={setDate}/></div>
        <div><div className="lbl">{t("Doza (opțional)")}</div><input value={dose} onChange={e=>setDose(e.target.value)} placeholder={t("ex: doza 1, rapel")}/></div>
      </div>
      <div style={{marginBottom:12}}>
        <div className="lbl">{t("Următoarea doză (opțional)")}</div>
        <DatePicker value={nextDate} onChange={setNextDate} placeholder={t("ZZ.LL.AAAA")}/>
      </div>
      <div style={{marginBottom:20}}>
        <div className="lbl">{t("Notițe (opțional)")}</div>
        <textarea value={note} onChange={e=>setNote(e.target.value)} rows={2} placeholder={t("ex: lot, reacții, medic")}/>
      </div>
      <button className="bp" style={{width:"100%"}} onClick={()=>{
        if(!finalName.trim()){fmAlert(t("Selectează sau scrie un vaccin"));return;}
        onAdd({
          ...(initial?._dbId?{_dbId:initial._dbId}:{}),
          name:finalName.trim(),
          date:displayToISO(date),
          dose:dose.trim(),
          note:note.trim(),
          nextDate:nextDate?displayToISO(nextDate):""
        });
      }}>{initial?._dbId?t("Salvează"):t("Adaugă vaccin")}</button>
    </div>
  );
}
